var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"pa-4",attrs:{"flat":""}},[_c('Header',{attrs:{"idClass":_vm.idClass,"count":_vm.table.dataTable.length},on:{"setIdClass":newValue => (_vm.idClass = newValue),"search":newValue => (_vm.table.search = newValue)}}),_c('Table',{attrs:{"table":_vm.table,"idClass":_vm.idClass}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }